import { type Actor, Service } from "@zapier/canvas-state";
import { shouldShowAppIcon } from "./shouldShowAppIcon";

type Params = {
  apps?: Service[] | undefined;
  actors: Actor[] | undefined;
  hasNote: boolean;
};

type AppItem = {
  type: "app";
  appId: string;
};

type ActorItem = {
  type: "actor";
  actor: Actor;
};

type NotesItem = {
  type: "notes";
};

export type StepSummaryItem = AppItem | ActorItem | NotesItem;

export function getItemsForStepSummary({
  apps,
  actors,
  hasNote,
}: Params): StepSummaryItem[] {
  const items = [];

  const appIds = apps?.map((app) => app.currentImplementation.id);
  const appIdsToShowAppIcons = appIds?.filter((appId) =>
    shouldShowAppIcon({
      appId,
    }),
  );

  if (appIdsToShowAppIcons) {
    items.push(
      ...appIdsToShowAppIcons.map((appId) => {
        return {
          type: "app",
          appId,
        } as AppItem;
      }),
    );
  }

  const haveActors = actors && actors.length > 0;

  if (haveActors) {
    items.push(
      ...actors.map(
        (actor) =>
          ({
            type: "actor",
            actor,
          }) as ActorItem,
      ),
    );
  }

  if (hasNote) {
    items.push({
      type: "notes",
    } as NotesItem);
  }

  return items;
}
